import React, { Component } from 'react';
import './all-questions.scss';
import { Constants, ImageConstants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import CwContentViewer from '../../../common/cw-content-viewer/cw-content-viewer'
import CanvasPreview from '../../../common/canvas/canvas'
import TestApi from '../../../../apis/test'
import GeometryTranspiler from '../../../common/geometry/geometry-parser'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faEllipsisV, faExpandArrowsAlt, faArrowLeft, faArrowRight, faDotCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalBody } from 'reactstrap';
import HomeworkApi from '../../../../apis/homework';
import CommonUtils from '../../../../utility/common-utilities';
import ReactTooltip from 'react-tooltip';

class AllQuestions extends Component {

    state = {
        completedStudents: [],
        notCompletedStudents: [],
        questions: [],
        usersInfo: [],
        showImage: []
    }


    // selectedItem = {

    // }


    // constructor(props) {
    //     super(props)

    //     console.log(this.props.selectedItem)

    //     let chaptersList = []

    //     chaptersList.push(this.props.match.params.chapter)


    //     this.selectedItem = {
    //         chapters: chaptersList,
    //         class: this.props.match.params.class,
    //         createdDate: this.props.match.params.createdDate,
    //         _id: this.props.match.params.homeworkId
    //     }

    //     console.log(this.selectedItem)

    // }

    order = { "CORRECT": 1, "IN_CORRECT": 2 };

    componentDidMount() {

        console.log(this.props.selectedItem)
        if (this.props.type) {
            this.getHomeworkAllQuestionList()
        } else {
            this.getAllQuestionList()
        }

        document.addEventListener('mousedown', this.handleClickEvent, false);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickEvent, false);
    }

    handleClickEvent = (event) => {
        if (this.studentRef && !this.studentRef.contains(event.target)) {
            this.setState({ showStudentIndex: -1 })
        }
    }

    getAllQuestionList(payload = {}) {

        payload.assessmentId = this.props.selectedItem?._id
        TestApi.getAllQuestionList(payload)
            .then(response => {
                console.log(response)
                this.setState({ questions: response.questions || [], basePath: response.basePath })
            }).catch(err => {
            })
    }

    getHomeworkAllQuestionList(payload = {}) {
        payload.homeworkId = this.props.selectedItem?._id
        HomeworkApi.getHomeworkAllQuetionsReport(payload)
            .then(response => {
                console.log(response)
                this.setState({ questions: response.questions || [], basePath: response.basePath })
            }).catch(err => {
            })
    }

    getChapterNames(chapters) {
        let arr = []
        for (let i = 0; i < chapters.length; i++) {
            arr.push(chapters[i].title)
        }
        return arr.join(", ")
    }

    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb-1'>
                <span>{`${this.props.selectedItem?.class || ""} >`}</span>
                <span className='pl-2'>{`${this.props.selectedItem?.section || ""} >`}</span>
                <span className='pl-2'>{this.props.selectedItem?.chapters?.length ? this.getChapterNames(this.props.selectedItem?.chapters) : this.props.selectedItem?.chapter} {`>`} </span>
                <span className='pl-2'>{this.getDate(this.props.selectedItem?.createdDateTimestamp)}</span>
            </div>
        )
    }

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    onClickBack = () => {
        if (this.props.type) {
            this.props.close && this.props.close()
        } else {
            this.props.delegate && this.props.delegate.hideCompletionReport && this.props.delegate.hideCompletionReport()

        }


    }

    renderResultColor = (result) => {

        switch (result) {
            case 'Correct':
                return '#4CCAB7'

            case 'Incorrect':
                return '#FF7171'

            case 'Not Attempted':
                return '#FFC571'

            default:
                return '#FFC571'
        }

    }

    getBlankOptionValueDropDown(content) {

        let styles = {
            p: { fontSize: '23px', fontFamily: "Mont", fontStyle: 'normal', fontWeight: "500" }
        }

        if (content && content.items && content.items.length) {
            let correctItem = content.items.filter((item) => item.isCorrect);
            let correctAnswer = correctItem[0].content.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "");
            if (correctItem[0].content) {
                return <CwContentViewer content={correctAnswer} />
            } else {
                return <></>
            }
        }
        return <></>
    }

    getJsxForBlankTypeDropDown(option, index) {

        console.log(option, index, this.state.selectedDropDownIndex, this.props.isReadOnly)

        console.log(this.state.actionSheet)

        let styles = {
            p: { fontSize: '19px', fontFamily: "Mont", fontStyle: 'normal', fontWeight: "500" }
        }

        return (
            <div className="position-relative" style={{}}>

                {this.state.selectedDropDownIndex === index ?
                    <>
                        <div className="row mb-2 mt-2 mr-0 ml-0" style={{}}>

                            <div className="blank-wrapper padding-for-dropdown">
                                <div className="dropdown-input">
                                    <div className="d-inline-block alphabet-option ml-2 mr-2">
                                        <div className="circle">{CommonUtils.getAlphabet(index).toUpperCase()}</div>
                                    </div>
                                    {/* <img className="option-separator-2" src={getThemeImageSource(ImageConstants.OPTION_SEPARATOR, this.props.categoryThemeId)} /> */}
                                    <div className="d-inline-block ml-2" style={{}}>
                                        {
                                            option.selectedText ?
                                                this.parser.parseWithStyles(`${option.selectedText.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "")}`, { p: styles.p, "cw-math": styles.p })
                                                : <span className="cw-input-for-dropdown" style={{}}>
                                                    {"Select One"}</span>
                                        }
                                    </div>

                                    <div className="float-right mt-2" style={{}}>
                                        <img className="dropdown-arrow-size" src={getImageSource(ImageConstants.DROPDOWN_ARROW_BLACK)} />
                                    </div>
                                </div>

                            </div>


                            {/* </LinearGradient> */}
                        </div>
                        {/* {this.state.actionSheet && <ActionSheet modal={this.state.actionSheet} toggleActionSheet={this.toggleActionSheet} options={this.state.dropDownData} onSelect={this.onSelect} categoryThemeId={this.props.categoryThemeId}></ActionSheet>} */}

                    </>


                    :
                    // <LinearGradient colors={Colors.appTheme.gradient1} start={{ x: 0, y: 0 }} end={{ x: 0, y: 1.2 }} style={styles.linearGradiendCard}>
                    <div className="row  mb-2 mt-2 mr-0 ml-0 cursor-pointer" style={{}}>

                        <div className="blank-wrapper padding-for-dropdown">
                            <div className="dropdown-input">
                                <div className="d-inline-block alphabet-option ml-2 mr-2">
                                    <div className="circle">{CommonUtils.getAlphabet(index).toUpperCase()}</div>
                                </div>
                                <img className="option-separator-2" src={getImageSource(ImageConstants.OPTION_SEPARATOR)} />
                                {
                                    // !this.props.isReadOnly ?
                                    //     <div className="d-inline-block ml-2" style={{}}>
                                    //         {
                                    //             option.selectedText ?
                                    //                 this.parser.parseWithStyles(`${option.selectedText.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "")}`, { p: styles.p, "cw-math": styles.p })
                                    //                 : <span className="cw-input-for-dropdown" style={{}}>
                                    //                     {"Select One"}</span>
                                    //         }
                                    //     </div>
                                    //     :
                                    <div className="d-inline-block ml-2" style={{}}>
                                        {this.getBlankOptionValueDropDown(option)}
                                    </div>
                                }

                                <div className="float-right mt-2" style={{}}>
                                    {/* <img className="dropdown-arrow-size" src={getImageSource(ImageConstants.ARROW_DOWN_ANGLE)} /> */}
                                </div>
                            </div>

                        </div>


                        {/* </LinearGradient> */}
                    </div>
                }

            </div>

        )
    }

    getBlankOptionValue = (content) => {

        let styles = {
            p: { fontSize: '20px', fontFamily: "Mont", fontStyle: 'normal', fontWeight: "500" }
        }

        if (content && content.items && content.items.length) {
            // let parsedJsx = this.parser.parseWithStyles(`${content.items[0].content.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "")}`, { p: styles.p, "cw-math": styles.p })
            return (
                <div className="d-inline-block ml-2">
                    <CwContentViewer content={content.items[0].content.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "")} />
                </div>
            )
        }
        return <></>
    }

    getJsxForBlank(option, index) {
        return (
            <div className="">

                <div >
                    {/* <LinearGradient colors={Colors.appTheme.gradient1} start={{ x: 0, y: 0 }} end={{ x: 0, y: 1.2 }} style={styles.blank}> */}

                    <div className="row  mb-2 mt-2 mr-0 ml-0">
                        <div className="blank-wrapper d-flex align-items-center ">
                            <div className="blank-option">
                                <div className="d-inline-block alphabet-option ml-2 mr-2">
                                    <div className="circle">{CommonUtils.getAlphabet(index).toUpperCase()}</div>
                                </div>

                                <img className="option-separator" src={getImageSource(ImageConstants.OPTION_SEPARATOR)} />

                                {
                                    this.getBlankOptionValue(option)

                                }

                            </div>

                            {/* <TouchableOpacity onPress={() => this.textInput[index].focus()} style={styles.keyboard} >
                                <Image source={getThemeImageSource(ImageConstants.ASSESSMENT_KEYBOARD, this.props.categoryThemeId)} />
                            </TouchableOpacity> */}
                        </div>
                        {/* </LinearGradient> */}
                    </div>
                </div>
            </div >


        )
    }

    getContentUsingContentType(option, style) {

        let content = option.content.replace(/^(<p>(\s|&nbsp;)*<\/p>)*/, "");

        content = content.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "");

        if (option.contentType == 1) {
            return <CwContentViewer content={content} />
        } else if (option.contentType == 2) {
            return <div className=''>
                <img className='image-option-container' src={option.content} alt="" />
            </div>
        }

    }

    renderReadOnlyItem = (option) => {
        let options = option.items;
        return (
            options.map((option, i) => (
                <div className="group-items d-flex align-items-center justify-content-center position-relative">

                    {option.contentType == 1 ?
                        <div className="">
                            <div className="text-center">{this.getContentUsingContentType(option, 'answer')}</div>
                        </div>
                        :
                        <div className="">
                            <div className="text-center">{this.getContentUsingContentType(option, 'answer')}</div>
                        </div>

                    }
                </div>
            ))
        )
    }



    getContentTypeOptionsForMultiStep(content, questionNo) {
        console.log(content)

        let isMultiStep = content.content.isMultiStep ? content.content.isMultiStep : false

        console.log(content.content)

        if (isMultiStep) {
            return content.content.steps.map((content, index) => (
                <>
                    <div className='row mt-4 mb-4 align-items-center'>
                        <div className='col-1 part-title'>
                            {questionNo + 1} {CommonUtils.getAlphabet(index)}
                        </div>
                        <div className='col part-question'>
                            <CwContentViewer content={content.content.title} />
                        </div>
                    </div>
                    {content.content.images && content.content.images.length ? content.content.images.map((image, imageIndex) =>
                        <img className='image-container mb-4 mr-3' src={image.imageUrl} alt="" />
                    )
                        :
                        ""}
                    {!this.state.showSubmissions ? <></> : this.renderContentType(content.content.type, content)}
                </>
            ))
        }
    }

    renderContentType = (contentType, content) => {

        switch (contentType) {

            case 1:
                return (
                    <div>
                        <div className='margin-for-options'>
                            {content.content.options.map((item, index) =>
                                <div className='mb-2 ml-2 row sequence-option'>
                                    <div className='col-1 option-max-width'>
                                        <div className='radio-btn'><div className={`${item.isCorrect === true ? 'inner-selected' : ''}`}></div></div>
                                    </div>
                                    <div className='col align-self-center'>
                                        {item.contentTypeName == 'TEXT' ?
                                            // <span className='' dangerouslySetInnerHTML={{ __html: item.content }} />
                                            <CwContentViewer content={item.content} />
                                            :
                                            <div className=''>
                                                <img className='image-option-container' src={item.content} alt="" />
                                            </div>
                                        }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 2:
                return (
                    <div>
                        <div className='margin-for-options'>
                            {content.content.options.map((item, index) =>
                                <div className='mb-2 ml-2 row sequence-option'>
                                    <div className='col-1 option-max-width'>
                                        <div className='check-box'> {item.isCorrect === true ? <img className="tick-mark-size" src={getImageSource(ImageConstants.TICK_MARK_ICON)} /> : <></>}</div>
                                    </div>
                                    <div className='col'>{item.contentTypeName == 'TEXT' ?
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 3:

                return (
                    <div>
                        <div className='margin-for-options'>
                            {
                                content.content.options && content.content.options.length && content.content.options.map((option, index) => (
                                    <React.Fragment key={'fillInTheBlank' + index}>
                                        {option.contentType == 3 ?
                                            this.getJsxForBlank(option, index)
                                            : this.getJsxForBlankTypeDropDown(option, index)
                                        }
                                    </React.Fragment>
                                ))
                            }
                        </div>
                    </div>
                )

            case 4:
                return (

                    <div className='margin-for-options'>
                        <div className='row m-0 p-0'>
                            {content.content.options.map((item, index) =>
                                <div className='col-4 matching-option'>
                                    {item.question.contentTypeName == 'TEXT' ?
                                        // <div className='match-option' dangerouslySetInnerHTML={{ __html: item.answer.content }} />
                                        <div className='match-option'><CwContentViewer content={item.question.content} /></div>
                                        :
                                        <div className='match-option'>
                                            <img className='image-option-container' src={item.question.content} alt="" />
                                        </div>
                                    }
                                    <div className='text-center'><img className='match-arrow my-2' onClick={this.props.onClose} src={getImageSource(ImageConstants.MATCHING_ARROW)} /></div>
                                    {item.answer.contentTypeName == 'TEXT' ?
                                        // <div className='match-option' dangerouslySetInnerHTML={{ __html: item.answer.content }} />
                                        <div className='match-option'><CwContentViewer content={item.answer.content} /></div>
                                        :
                                        <div className='match-option'>
                                            <img className='image-option-container' src={item.answer.content} alt="" />
                                        </div>
                                    }
                                </div>
                            )}

                        </div>
                    </div>

                )

            case 5:

                return (
                    <div>
                        <div className='margin-for-options'>
                            {content.content.options.map((item, index) =>
                                <div className='mb-2 ml-2 row sequence-option'>
                                    <div className='col-2 drag-arrow-max-width'>
                                        <img className='match-arrow drag-container' onClick={this.props.onClose} src={getImageSource(ImageConstants.DRAG_ICON)} />
                                    </div>
                                    <div className='sequence-border'></div>
                                    <div className='col '>{item.contentTypeName == 'TEXT' ?
                                        // <span className='' dangerouslySetInnerHTML={{ __html: item.content }} />
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 6:

                let items = []

                for (let i = 0; i < content.content.options.length; i++) {
                    items = items.concat(content.content.options[i].items)
                }
                return (
                    <div className='margin-for-options'>
                        {/* <div className='row option-wrapper '>
                            {items.map((item, index) =>
                                <div className='ml-2 mt-2'> {item.contentTypeName == 'TEXT' ?
                                    // <div className='group-items' dangerouslySetInnerHTML={{ __html: item.content }} />
                                    <div className='group-items'><CwContentViewer content={item.content} /></div>
                                    :
                                    <div className='group-items'>
                                        <img className='image-option-container' src={item.content} alt="" />
                                    </div>
                                }</div>
                            )}
                        </div> */}
                        <div className="matching-question-container d-flex flex-row mt-4">
                            {content.content.options.map((option, index) => (
                                <div key={"dropZone" + index} className="drop-zone">
                                    <div className="text-center p-1 drop-zone-title">
                                        <CwContentViewer content={option.title} />
                                    </div>
                                    <div className="d-flex flex-row answer-wrapper justify-content-center">
                                        {
                                            this.renderReadOnlyItem(option)
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )

            case 10:
                if (content && content.content && content.content.canvas && content.content.canvas.render && content.content.canvas.render.script && content.content.canvas.render.script) {
                    let payload = GeometryTranspiler.transpile(content.content.canvas.render.script, 37.7952755906, 5) //centimeter ratio and x offset
                    if (payload) {
                        let { maxWidth, maxHeight } = this.getCanvasSize(payload)
                        this.canvasMaxWidth = maxWidth + 100
                        this.canvasMaxHeight = maxHeight + 100
                    }

                    return (
                        <CanvasPreview id={Math.random()} coordinates={payload || []} maxWidth={this.canvasMaxWidth} maxHeight={this.canvasMaxHeight} />
                    )
                }

            default:
                return (<div className='text-center'><b>COMING SOON</b></div>)
        }

    }

    // renderContentType = (contentType, content) => {

    //     switch (contentType) {

    //         case 1:
    //             return (
    //                 <div>
    //                     <div className='row'>
    //                         {content.content.options.map((item, index) =>

    //                             <div className='col col-lg-6 col-md-6 col-sm-12'>
    //                                 <div className={`mb-4 ml-2 row sequence-option ${item.isCorrect ? 'correct-answer-light-border' : ''} `} >
    //                                     <div className='col-1 my-auto col-min-width'>
    //                                         {item.isCorrect && <img className='answer-result-icon' src={getImageSource(ImageConstants.CORRECT_ANSWER)} onClick={() => this.onClickBack()} />}
    //                                     </div>
    //                                     <div className='col my-auto'>{item.contentTypeName == 'TEXT' ?
    //                                         <CwContentViewer content={item.content} />
    //                                         :
    //                                         <div className=''>
    //                                             <img className='image-option-container' src={item.content} alt="" />
    //                                         </div>
    //                                     }
    //                                     </div>

    //                                 </div>
    //                             </div>

    //                         )}

    //                     </div>
    //                 </div >

    //             )

    //         case 2:
    //             return (
    //                 <div className="row">
    //                     {content.content.options.map((item, index) =>
    //                         <div className="col col-lg-6 col-md-6 col-sm-11">

    //                             <div className='mb-4 ml-2 row sequence-option'>
    //                                 <div className='col-1 my-auto'>
    //                                     <div className='check-box'></div>
    //                                 </div>
    //                                 <div className='col my-auto'>{item.contentTypeName == 'TEXT' ?
    //                                     <CwContentViewer content={item.content} />
    //                                     :
    //                                     <div className=''>
    //                                         <img className='image-option-container' src={item.content} alt="" />
    //                                     </div>
    //                                 }
    //                                 </div>
    //                             </div>

    //                         </div>
    //                     )}

    //                 </div>

    //             )

    //         case 4:
    //             return (

    //                 <div className='mb-4'>
    //                     <div className='row'>
    //                         {content.content.options.map((item, index) =>
    //                             <div className={`col-2 matching-option my-auto `} style={{ borderColor: 'red' }}>
    //                                 {item.question.contentTypeName == 'TEXT' ?
    //                                     <div className='match-option'><CwContentViewer content={item.question.content} /></div>
    //                                     :
    //                                     <div className='match-option'>
    //                                         <img className='image-option-container' src={item.question.content} alt="" />
    //                                     </div>
    //                                 }
    //                                 <div className='text-center'><img className='match-arrow my-2' onClick={this.props.onClose} src={getImageSource(ImageConstants.MATCHING_ARROW)} /></div>
    //                                 {item.answer.contentTypeName == 'TEXT' ?
    //                                     <div className='match-option'><CwContentViewer content={item.answer.content} /></div>
    //                                     :
    //                                     <div className='match-option'>
    //                                         <img className='image-option-container' src={item.answer.content} alt="" />
    //                                     </div>
    //                                 }
    //                             </div>
    //                         )}

    //                     </div>
    //                 </div>

    //             )

    //         case 5:

    //             return (
    //                 <div className='mb-4'>
    //                     <div >
    //                         {content.content.options.map((item, index) =>
    //                             <div className='mb-4 ml-2 row sequence-option'>
    //                                 <div className='col-2 my-auto'>
    //                                     <img className='match-arrow drag-container' onClick={this.props.onClose} src={getImageSource(ImageConstants.DRAG_ICON)} />
    //                                 </div>
    //                                 <div className='sequence-border'></div>
    //                                 <div className='col my-auto'>{item.contentTypeName == 'TEXT' ?
    //                                     <CwContentViewer content={item.content} />
    //                                     :
    //                                     <div className=''>
    //                                         <img className='image-option-container' src={item.content} alt="" />
    //                                     </div>
    //                                 }
    //                                 </div>

    //                             </div>
    //                         )}

    //                     </div>
    //                 </div>

    //             )

    //         case 6:

    //             let items = []

    //             for (let i = 0; i < content.content.options.length; i++) {
    //                 items = items.concat(content.content.options[i].items)
    //             }
    //             return (
    //                 <div className='mb-4'>
    //                     <div className='row option-wrapper '>
    //                         {items.map((item, index) =>
    //                             <div className='ml-2 mt-4'> {item.contentTypeName == 'TEXT' ?
    //                                 <div className='group-items'><CwContentViewer content={item.content} /></div>
    //                                 :
    //                                 <div className='group-items'>
    //                                     <img className='image-option-container' src={item.content} alt="" />
    //                                 </div>
    //                             }</div>
    //                         )}
    //                     </div>
    //                     <div className='row mt-4'>
    //                         {content.content.options.map((item, index) =>
    //                             <div className='ml-2 group-option'>
    //                                 <div className='group-header px-3'>
    //                                     <div className='text-center mt-2'><CwContentViewer content={item.title} /></div>
    //                                 </div>

    //                             </div>
    //                         )}

    //                     </div>
    //                 </div>
    //             )

    //         case 10:
    //             if (content?.content?.canvas?.render?.script) {
    //                 let payload = GeometryTranspiler.transpile(content.content.canvas.render.script, 37.7952755906, 5) //centimeter ratio and x offset
    //                 if (payload) {
    //                     let { maxWidth, maxHeight } = this.getCanvasSize(payload)
    //                     this.canvasMaxWidth = maxWidth + 100
    //                     this.canvasMaxHeight = maxHeight + 100
    //                 }

    //                 return (
    //                     <CanvasPreview id={Math.random()} coordinates={payload} maxWidth={this.canvasMaxWidth} maxHeight={this.canvasMaxHeight} />
    //                 )
    //             }

    //         default:
    //             return ("")
    //     }

    // }
    getCanvasSize(coordinates = []) {
        if (!coordinates) return {}
        let maxHeight = 0, maxWidth = 0
        for (let i = 0; i < coordinates.length; i++) {
            for (let j = 0; j < coordinates[i].points.length; j++) {
                if (maxWidth < coordinates[i].points[j].x) {
                    maxWidth = coordinates[i].points[j].x
                }
                if (maxHeight < coordinates[i].points[j].y) {
                    maxHeight = coordinates[i].points[j].y
                }
            }
        }
        return { maxHeight, maxWidth }
    }

    showSubmissions = (item, index) => {

        if (item?.stats?.users?.length) {
            let users = item.stats.users

            users = users.sort((a, b) => this.order[a.status] - this.order[b.status])

            item.stats.users = users
        }


        this.setState({ showSubmissions: true, selectedQuestion: item, selectedIndex: index })
    }

    toggleBack = () => {

        if (this.state.showSubmissions) {
            this.setState({ showSubmissions: false })
        } else {
            this.props.close()
        }

    }

    getStatusText(value) {
        if (value == "CORRECT") return "Correct"
        else if (value == "IN_CORRECT") return "Incorrect"
        return "Not Attempted"
    }

    getStatusColor(value) {
        if (value == "CORRECT") return "text-success"
        else if (value == "IN_CORRECT") return "text-danger"
        return "text-warning"
    }

    onClickStatus(item, index, status) {
        console.log(item, index, status)

        let stats = item.stats

        let students = []

        if (status == "CORRECT") {
            students = stats?.correctUsers || []
        } else if (status == "IN_CORRECT") {
            students = stats?.inCorrectUsers || []
        } else if (status == "NOT_ATTEMPTED") {
            students = stats?.notAttemptedUsers || []
        }

        this.setState({ selectedQuestion: item, students, showStudentIndex: index, status })

        console.log(this.state.students)

    }

    closeStudents() {
        this.setState({ selectedItem: null, showStudentIndex: -1, reload: true }, () => {
            this.setState({ reload: false })
        })
    }


    showImageFullScreen = (images, index) => {

        const { showImage } = this.state
        showImage[index] = 0



        this.setState({
            currentIndex: index,
            selectedImages: images,
            showImageFullScreen: true,
            showImage
        })
    }

    hideImageFullScreen = _ => {
        this.setState({
            currentIndex: 0,
            selectedImages: [],
            showImageFullScreen: false
        })
    }

    changeImageIndex = (qIndex, iIndex) => {
        const { showImage } = this.state
        showImage[qIndex] = iIndex
        this.setState({
            showImage
        })
    }

    goToPrevImage = (qIndex) => {
        const { showImage } = this.state
        if (!showImage[qIndex] || showImage[qIndex] === 0) return
        showImage[qIndex] = showImage[qIndex] - 1
        this.setState({
            showImage
        })
    }

    goToNextImage = (qIndex, length) => {
        const { showImage } = this.state
        if (showImage[qIndex] === length - 1) return
        showImage[qIndex] = !showImage[qIndex] ? 1 : showImage[qIndex] + 1
        this.setState({
            showImage
        })
    }

    renderFullScreenImage() {
        const {
            selectedImages,
            currentIndex,
            showImage
        } = this.state
        const index = currentIndex;
        return (
            <Modal className="cw-custom-modal image-full-screen" isOpen={true} toggle={this.hideImageFullScreen} size={"xl"}>
                <ModalBody >
                    <div className="row px-2">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideImageFullScreen} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="px-5">
                        <div className='answer-image-container' >
                            {selectedImages?.length > 0 && selectedImages.map((image, imageIndex) => (
                                <>
                                    {((showImage[index] === imageIndex) || (!showImage[index] && imageIndex === 0)) && <div className='answer-image text-center' key={imageIndex}>
                                        <img className='answer-image' src={image.url} />
                                    </div>
                                    }

                                </>
                            ))}
                            {selectedImages?.length > 0 &&
                                <div className='slider-pagination-buttons'>
                                    <div className='prev cursor-pointer' onClick={_ => {
                                        this.goToPrevImage(index)
                                    }}>
                                        <FontAwesomeIcon color='#FFFFFF' icon={faArrowLeft} />
                                    </div>
                                    {selectedImages.map((image, imageIndex) => (
                                        <div className='slider-page cursor-pointer' key={imageIndex} onClick={_ => {
                                            this.changeImageIndex(index, imageIndex)
                                        }}>
                                            <div className={`dot-circle ${((showImage[index] === imageIndex) || (!showImage[index] && imageIndex === 0)) ? "active" : ""}`}>

                                            </div>
                                        </div>
                                    ))}
                                    <div className='next cursor-pointer' onClick={_ => {
                                        this.goToNextImage(index, selectedImages.length)
                                    }}><FontAwesomeIcon color='#FFFFFF' icon={faArrowRight} /></div>
                                </div>
                            }
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    renderStudentCard() {
        return (
            <div className='students-card' ref={ref => this.studentRef = ref}>

                <div className="row">
                    <div className="col">
                        <img className="close-icon cursor-pointer" onClick={(event) => this.closeStudents()} src={getImageSource(ImageConstants.CROSS)} />
                    </div>
                </div>

                {
                    this.state.students?.length ? this.state.students.map((item, index) =>
                        <div className='px-4 py-2 row align-items-center'>
                            <div className="profile-avatar text-center mr-2 d-inline-block">
                                <div className="row justify-content-center">
                                    {item.image ? <img className="" alt="img" src={`${this.state.basePath}${item.image}`} />
                                        :
                                        <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                </div>
                            </div>
                            <div className='student-name ml-2'>
                                {item.name}
                            </div>
                        </div>

                    )
                        :
                        <div className="text-center pt-4">No Student Attempted Classwork</div>
                }
            </div>
        )
    }

    render() {


        return (
            <div className='completion-report-1'>

                {/* <div className='ml-4' >
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.toggleBack()} />
                </div>

                <div className='container-1 mt-0'>


                    <div className='item-2'>
                        <div className="col screen-title p-0">{this.props?.title || this.state.showSubmissions ? "Submission at Question Level" : "All Questions"}</div>
                    </div>
                </div>
                <div className=''>{this.renderBreadcrumb()}</div> */}
                <div className='item1 mb-3' >
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.toggleBack()} />
                </div>

                <div className='d-flex align-items-center justify-content-between header-report-card mb-3'>
                    <div className='d-flex align-items-center'>
                        <div>
                            <img className='circle-image' src={getImageSource(ImageConstants.ALL_QUESTIONS_DETAIL_REPORT)} />
                        </div>
                        <div className='ml-2'>
                            <div className=''>
                                <span className='screen-title-1 title-center'>{this.props?.title || this.state.showSubmissions ? "Submission at Question Level" : "All Questions"}</span>
                                <span>{this.renderBreadcrumb()}</span>
                            </div>
                        </div>
                    </div>
                </div>


                {/* <div className=" pt-4 mb-5" >
                    <div className="col screen-title p-0">{this.props?.title || this.state.showSubmissions ? "Submission at Question Level" : "All Questions"}</div>
                    <div className=''>{this.renderBreadcrumb()}</div>
                </div> */}

                {!this.state.showSubmissions ? <div className='answer-sheet'>
                    <div className='cw-plain-card cw-answer-sheet-card-wrapper mt-4 mb-4 ml-4 mr-2'>
                        {this.state.questions && this.state.questions.length ?
                            this.state.questions.map((item, index) =>
                                <div className="" onMouseEnter={ReactTooltip.rebuild}>
                                    {/* {
                                        this.props.type ? <img className='info-icon-size float-right' src={getImageSource(ImageConstants.INFO1)} data-tip={item.stats.eloTitle} /> : <></>
                                    } */}
                                    {
                                        <img className='info-icon-size float-right cursor-pointer' src={getImageSource(ImageConstants.INFO1)} data-tip={item.stats.eloTitle} />
                                    }


                                    <div className='row mb-2 question-container'>
                                        <div className='sub-title'>Question {index + 1} - <img className='exam-pad-icon' src={getImageSource(ImageConstants.EXAM_PAD_ICON_BLOCK)} /> {item.mark}</div>
                                        {/* <div className=''> */}

                                        {/* </div> */}
                                        <div className='row mr-4'>
                                            <div className='mr-4 change-color cursor-pointer' onClick={() => this.showSubmissions(item, index)}>{'View Submissions >>'}</div>
                                        </div>
                                    </div>

                                    {/* <div className='row'> */}
                                    <div className=''>
                                        <CwContentViewer content={item.content.title} />
                                        {item.content.images && item.content.images.length ? item.content.images.map((image, imageIndex) =>
                                            <img className='image-container mb-4 mr-3' src={image.imageUrl} alt="" />
                                        )
                                            :
                                            ""}

                                        {item.content.isMultiStep ? this.getContentTypeOptionsForMultiStep(item, index, this.state.showSubmissions) : <></>}
                                        {/* <div className='mt-3'>{this.renderContentType(item.content.type, item)}</div> */}
                                        <div className='row mt-3 status-wrapper'>
                                            <div className='row status-row'>
                                                <div className='dot green-dot'></div>
                                                <span className='roll-no cursor-pointer' onClick={() => this.onClickStatus(item, index, "CORRECT")}>Correct : <strong>{item?.stats?.correct || 0}</strong></span>
                                                {
                                                    this.state.showStudentIndex === index && this.state.status == "CORRECT" ? this.renderStudentCard() : ""
                                                }
                                            </div>
                                            <div className='row ml-5 status-row'>
                                                <div className='dot red-dot'></div>
                                                <div className='roll-no cursor-pointer' onClick={() => this.onClickStatus(item, index, "IN_CORRECT")}> In-Correct : <strong>{item?.stats?.inCorrect || 0}</strong></div>
                                                {
                                                    this.state.showStudentIndex === index && this.state.status == "IN_CORRECT" ? this.renderStudentCard() : ""
                                                }
                                            </div>

                                            {!this.props.type && <div className='row ml-5 status-row' >
                                                <div className='dot yellow-dot'></div>
                                                <div className='roll-no cursor-pointer' onClick={() => this.onClickStatus(item, index, "NOT_ATTEMPTED")} > Not Attempted : <strong>{item?.stats?.notAttempted || 0}</strong></div>
                                                {
                                                    this.state.showStudentIndex === index && this.state.status == "NOT_ATTEMPTED" ? this.renderStudentCard() : ""
                                                }
                                            </div>
                                            }


                                        </div>
                                    </div>
                                    {index != this.state.questions.length - 1 && <div className='text-center'><img className="separator" src={getImageSource(ImageConstants.SEPARATOR)} /></div>}

                                </div>
                            ) : <div className="text-center">No Student Attempted Classwork</div>}
                    </div>

                </div > : ""
                }

                {
                    this.state.showSubmissions ?
                        <div className="">

                            <div className='row cw-plain-card card-background cw-answer-sheet-card-wrapper mx-1 ml-4 mr-2'>

                                <div className='col-12'>
                                    <div className='row mx-1 mb-3 submission-question-container'>
                                        <div className='sub-title'>Question {this.state.selectedIndex + 1} - <img className='exam-pad-icon' src={getImageSource(ImageConstants.EXAM_PAD_ICON_BLOCK)} /> {this.state.selectedQuestion.mark}</div>

                                    </div>
                                    <CwContentViewer content={this.state.selectedQuestion.content.title} />
                                    {this.state.selectedQuestion.content.images && this.state.selectedQuestion.content.images.length ? this.state.selectedQuestion.content.images.map((image, imageIndex) =>
                                        <img className='image-container mb-4 mr-3' src={image.imageUrl} alt="" />
                                    )
                                        :
                                        ""}
                                    {this.state.selectedQuestion.content.isMultiStep ? this.getContentTypeOptionsForMultiStep(this.state.selectedQuestion, this.state.selectedIndex) : this.renderContentType(this.state.selectedQuestion.content.type, this.state.selectedQuestion)}
                                    {/* <div className='mt-3'>{this.renderContentType(this.state.selectedQuestion.content.type, this.state.selectedQuestion)}</div> */}
                                    <div className='row mt-3 status-wrapper'>
                                        <div className='row ' >
                                            <div className='dot green-dot'></div>
                                            <span className='roll-no cursor-pointer' onClick={() => this.onClickStatus(this.state.selectedQuestion, 1, "CORRECT")}>Correct : <strong>{this.state.selectedQuestion?.stats?.correct || 0}</strong></span>
                                            {
                                                this.state.showStudentIndex === 1 && this.state.status == "CORRECT" ? this.renderStudentCard() : ""
                                            }
                                        </div>
                                        <div className='row ml-5' >
                                            <div className='dot red-dot'></div>
                                            <div className='roll-no cursor-pointer' onClick={() => this.onClickStatus(this.state.selectedQuestion, 2, "IN_CORRECT")}>In-Correct : <strong>{this.state.selectedQuestion?.stats?.inCorrect || 0}</strong></div>
                                            {
                                                this.state.showStudentIndex === 2 && this.state.status == "IN_CORRECT" ? this.renderStudentCard() : ""
                                            }
                                        </div>
                                        {
                                            !this.props.type && <div className='row ml-5'  >
                                                <div className='dot yellow-dot'></div>
                                                <div className='roll-no cursor-pointer' onClick={() => this.onClickStatus(this.state.selectedQuestion, 3, "NOT_ATTEMPTED")}>Not Attempted : <strong>{this.state.selectedQuestion?.stats?.notAttempted || 0}</strong></div>
                                                {
                                                    this.state.showStudentIndex === 3 && this.state.status == "NOT_ATTEMPTED" ? this.renderStudentCard() : ""
                                                }
                                            </div>
                                        }

                                    </div>
                                    <div className='text-center align-items-center'><img className="separator" src={getImageSource(ImageConstants.SEPARATOR)} /></div>
                                </div>


                                {/* <div id="table-scoll" className="table-responsive mt-8">
                                    <table className="table cw-table mb-0 align-items-center custom-test-table">
                                        <tbody className="bg-white"> */}
                                {/* {

                                                <> */}

                                <div id="table-scoll" className="table-responsive" style={{
                                    background: "#F5F6FA",
                                    border: "1px solid #F5F6FA"
                                }}>
                                    <table className="table cw-table">
                                        <thead>
                                            <tr>
                                                <th className='th-left-radius name-padding'>Student Name</th>
                                                <th className='text-center'>Roll No</th>
                                                {/* <th className='text-center'>Marks</th> */}
                                                <th className='text-center'>Result</th>
                                                <th className='th-right-radius text-center'>Workings</th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white">
                                            {
                                                this.state.selectedQuestion?.stats?.users?.length ? this.state.selectedQuestion?.stats?.users?.map((item, index) => (
                                                    <>
                                                        <tr key={item._id} className=" mt-4">
                                                            <td className="name-padding">{
                                                                item.image ?
                                                                    <img className='student-image-1' src={`${this.state.basePath}${item.image}`} />
                                                                    :
                                                                    <img className='student-image-1' src={Constants.ALTERNATE_STUDENT_IMAGE} />
                                                            }

                                                                <span className='ml-2'>{item.name}</span>
                                                            </td>
                                                            <td className='text-center'>{item.rollNo}</td>
                                                            {/* <td className='text-center'>{item.mark} </td> */}
                                                            {/* <td className="text-center"><span className={this.getStatusColor(item.status)}><b>{this.getStatusText(item.status)}</b></span></td> */}
                                                            <td className="text-center">
                                                                {item.status === "CORRECT" && <img className='answer-result-icon' src={getImageSource(ImageConstants.CORRECT_ANSWER)} />}
                                                                {item.status === "IN_CORRECT" && <img className='answer-result-icon' src={getImageSource(ImageConstants.WRONG_ANSWER)} />}

                                                            </td>
                                                            <td className='text-center'>{item.attachments?.length ? <span className='view-image' onClick={() => this.showImageFullScreen(item.attachments, index)}>View Workings</span> : '-'}</td>
                                                        </tr>
                                                        {/* {
                                                            this.state.selectedQuestion?.stats?.users?.length - 1 != index ?
                                                                <tr className="p-0 m-0">
                                                                    <td className="p-0 m-0" colSpan="5" align='center'><img className="separator-1" src={getImageSource(ImageConstants.SEPARATOR)} /></td>
                                                                </tr>
                                                                : ""
                                                        } */}
                                                    </>

                                                ))
                                                    : <tr className="bg-white pt-4"><td colSpan="11" align='center'>No Student Attempted Classwork</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div >

                                {/* </>


                                            } */}
                                {/* </tbody>
                                    </table>
                                </div > */}

                            </div>



                        </div> : ""
                }
                {this.state.showImageFullScreen && this.renderFullScreenImage()}
                <ReactTooltip className="border arrow" arrowColor="#C4C4C4" ref={el => this.tooltip = el}
                    multiline={true}
                    place='left'
                    type='light' effect='solid'
                    event="mouseover mouseenter"
                    eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div >

        );
    }
}

export default AllQuestions;